import { Row, Col, Image } from 'react-bootstrap';
import { HeadCell } from 'components/gifts-table/TableList';
import './styles.scss';

export default function ArticleCell(props) {
  const { image, productName, description, isBody } = props;
  return (
    <>
      {isBody ? (
        <td className="ArticleCell">
          <Row>
            <Col xs={5}>
              <Image src={image} className="ArticleCell__Image" />
            </Col>
            <Col
              xs={6}
              className="d-flex col-6 flex-column align-items-start justify-content-center"
            >
              <div>
                <p className="font-weight-bold">{productName}</p>
                <p>{description}</p>
              </div>
            </Col>
          </Row>
        </td>
      ) : (
        <HeadCell column={props} />
      )}
    </>
  );
}
